import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export const ProtectedRoute = ({ 
  children, 
  allowedRoles = ["admin", "candidate"] 
}) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  // While checking authentication state, show nothing
  if (isLoading) {
    return <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-primary border-t-primary"></div>
    </div>;
  }

  // If not authenticated, redirect to login
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user role is not allowed, redirect to appropriate page
  if (!allowedRoles.includes(user.role)) {
    return user.role === "admin" 
      ? <Navigate to="/admin/dashboard" replace /> 
      : <Navigate to="/candidate/dashboard" replace />;
  }

  // If authenticated and role is allowed, render children
  return <>{children}</>;
};
